import * as storeViewEvents from './domains/store-view'
import * as storeWallEvents from './domains/store-wall'
import * as testEvent from './domains/test-events'
import type { AnalyticsEventFactoryCollection } from '@/tools/analytics/types'

export const eventFactoryCollection = {
  ...testEvent,
  ...storeViewEvents,
  ...storeWallEvents,
} satisfies AnalyticsEventFactoryCollection<'perseus'>
